var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},_vm._l((_vm.tab_arr),function(item,index){return _c('div',{key:index,staticClass:"tab_item",style:({color:item.color})},[_vm._v("\n        "+_vm._s(item.title)+"\n    ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }